import React from 'react';
import './CTABanner.css';

const CTABanner: React.FC = () => {
  return (
    <section className="cta-banner">
      <div className="container">
        <p>Need a notary today? Contact us for same-day service.</p>
        <div className="cta-buttons">
          <a href="tel:+14374490147" className="btn btn-secondary">
            Call Now
          </a>
          <a href="#contact" className="btn btn-outline">
            Send a Message
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;